import * as React from "react";

import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import { cn } from "../../utils";

export const tooltipContentClassName =
  "af-z-50 af-origin-[--radix-tooltip-content-transform-origin] af-overflow-hidden af-rounded-md af-border af-bg-popover af-px-3 af-py-1.5 af-text-sm af-text-popover-foreground af-shadow-md af-animate-in af-fade-in-0 af-zoom-in-95 data-[state=closed]:af-animate-out data-[state=closed]:af-fade-out-0 data-[state=closed]:af-zoom-out-95 data-[side=bottom]:af-slide-in-from-top-2 data-[side=left]:af-slide-in-from-right-2 data-[side=right]:af-slide-in-from-left-2 data-[side=top]:af-slide-in-from-bottom-2";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = ({
  className,
  sideOffset = 4,
  ...props
}: React.ComponentProps<typeof TooltipPrimitive.Content>) => (
  <TooltipPrimitive.Portal>
    <TooltipPrimitive.Content
      sideOffset={sideOffset}
      className={cn(tooltipContentClassName, className)}
      {...props}
    />
  </TooltipPrimitive.Portal>
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
